import { useState, useEffect } from "react";
import BlogList from "./BlogList";

export default function BlogsPage({ categories }) {
  const [parsedCategories, setParsedCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeAuthor, setActiveAuthor] = useState(null);
  const getCategoryFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("category");
  };

  const getAuthorFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("author");
  };

  useEffect(() => {
    let parsed = categories
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean);
  
    if (!parsed.includes("All")) {
      parsed.unshift("All");
    }
    const urlAuthor = getAuthorFromURL();

    setActiveAuthor(urlAuthor || null);
  
    const finalCategories = parsed.length ? parsed : ["All"];
  
    setParsedCategories(finalCategories);
    setActiveCategory(finalCategories[0]); 

    const urlCategory = getCategoryFromURL();
  
    if (urlCategory) {
      const matched = finalCategories.find(
        (cat) =>
          cat.toLowerCase().replace(/\s+/g, "-") === urlCategory
      );
  
      if (matched) {
        setActiveCategory(matched);
      }
    }
  
  }, [categories]);

  return (
    <div className="layout-spacing">
      <div className="blogs-outer-wrapper">
        <div className="layout-padding">
          <div className="blogs-wrapper">


            {/* Tabs */}
            <div className="blog-tabs">
              {parsedCategories.map((cat) => (
                <button
                  key={cat}
                  className={`blog-tab ${
                    activeCategory === cat ? "active" : ""
                  }`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Blog List */}
            <BlogList category={activeCategory} author={activeAuthor} />

          </div>
        </div>
        </div>
    </div>
  );
}